import { MenuItem as CadArcMenuItem } from '@cad-arc';
import { ContextMenuItemView } from '@mark43/cad-api';

export function MenuItem({
    contextMenuItemView,
    onSelect,
}: {
    contextMenuItemView: ContextMenuItemView;
    onSelect: () => void;
}): React.ReactElement {
    const { isVisible, isEnabled, label } = contextMenuItemView;

    if (!isVisible) {
        return <></>;
    }

    return (
        <CadArcMenuItem isDisabled={!isEnabled} onSelect={onSelect}>
            {label}
        </CadArcMenuItem>
    );
}
